// Campus photo for /colleges/university-of-california-santa-barbara: CC BY-SA 4.0, by Coolcaesar, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AUCSB_University_Center_and_Storke_Tower.jpg), checked 2026-09-30 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-california-santa-barbara/; credited under the photo.
const photo = {
    "slug": "university-of-california-santa-barbara",
    "alt": "Storke Tower and the University Center across the lagoon at UC Santa Barbara in Santa Barbara, California",
    "src": "/colleges/university-of-california-santa-barbara/campus-1600.webp",
    "srcSmall": "/colleges/university-of-california-santa-barbara/campus-800.webp",
    "srcMid": "/colleges/university-of-california-santa-barbara/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-california-santa-barbara/og.jpg",
    "title": "UCSB University Center and Storke Tower",
    "author": "Coolcaesar",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AUCSB_University_Center_and_Storke_Tower.jpg",
    "read": "2026-09-30"
};

export default photo;
